import styles from "./MainPage.module.css"
import FormSection from "../../components/FormSection/FormSection"
import ImageSection from "../../components/ImageSection/ImageSection"
import AdvantagesSection from "../../components/AdvantagesSection/AdavantagesSection"
import ProcessSection from "../../components/ProcessSection/ProcessSection"
import ReviewsSection from "../../components/ReviewsSection/ReviewsSection"
import AdditionalQuestionsSection from "../../components/AdditionalQuestionsSection/AdditionalQuestionsSection"

export default function MainPage() {
  return(
    <div className={styles.mainPage}>
      <section className={styles.container_top}>
        <FormSection />
        <ImageSection />
      </section>
      <section className={styles.container}>
        <AdvantagesSection />
      </section>
      <section className={styles.container}>
        <ProcessSection />
      </section>
      <section className={styles.container}>
        <ReviewsSection />
      </section>
      <section className={styles.container}>
        <AdditionalQuestionsSection />
      </section>
    </div>
    
  )
}